
export const nav = {
  home: 'Inicio',
  assessment: 'Evaluación',
  results: 'Resultados',
  pricing: 'Precios',
  signIn: 'Iniciar Sesión',
  signOut: 'Cerrar Sesión',
  dashboard: 'Panel',
  admin: 'Admin',
  support: 'Soporte',
  recruitment: 'Reclutamiento',
  candidates: 'Candidatos',
  idealProfiles: 'Perfiles Ideales',
  orgChart: 'Organigrama',
  registrationLink: 'Enlace de Registro',
  translations: 'Traducciones',
  comparison: 'Optimización de Talento',
  positions: 'Posiciones',
  profiles: 'Perfiles',
  forms: 'Formularios',
  funnel: 'Embudo',
  team: 'Equipo'
};
